







































import { Pages } from '@/pages'
import { Vue, Component } from 'vue-property-decorator'
import VueCookies from 'vue-cookies'
import { mapGetters, mapState } from 'vuex'
import { permissions } from '@/userUtils'
import { ISnackbar } from '@/model'
import { IUser } from '@/libs/auth'

Vue.use(VueCookies)

@Component({
  computed: {
    ...mapGetters('user', ['userPermissions']),
    ...mapState('environment', ['user'])
  }
})
export default class ListButton extends Vue {
  private userPermissions!: string[]
  private user!: IUser
  private snackbar: ISnackbar = { show: false, color: '', text: '', timeout: 10000}

  get items () {
    const create = { id: 1, to: Pages.CREATEPALLETPATTERN.routeLink, avatar: 'build', title: this.$t('listButtons.newPal') }
    const view = { id: 2, to: Pages.VIEWPALLETPATTERNS.routeLink, avatar: 'view_list', title: this.$t('listButtons.savedPal') }
    return [create, view]
  }

  private userCanNotCreatePattern(itemId: number): boolean {
    return itemId === 1 && !this.userPermissions.includes(permissions.CREATEPALLETPATTERN)
  }

  private showAlert(itemId: number) {
    this.snackbar.show = false
    this.$nextTick(() => {
      if (this.userCanNotCreatePattern(itemId)) {
        this.snackbar.show = true
        this.snackbar.color = 'warning'
        this.snackbar.text = String(this.$t('settings.permissionDenied'))
      }
    })
  }

  private isExternalUser() {
    return this.user != null && this.user.external
  }
}
